var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0039 8.04305C22.0547 8.04305 7.50391 22.6284 7.50391 40.6202C7.50391 58.6121 22.0547 73.1974 40.0039 73.1974C57.9532 73.1974 72.5039 58.6121 72.5039 40.6202C72.5039 35.8149 71.466 31.2526 69.6025 27.1463L40.107 55.6974L39.8688 55.4502L22.7407 37.6799L28.1358 32.4576L40.2701 45.0886L65.6118 20.5582C59.663 12.9396 50.4039 8.04305 40.0039 8.04305ZM40 80.7125C17.9086 80.7125 0 62.7613 0 40.6175C0 18.4736 17.9086 0.522461 40 0.522461C62.0914 0.522461 80 18.4736 80 40.6175C80 62.7613 62.0914 80.7125 40 80.7125Z",
    fill: "#5AB52F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeCheckGreen);
export default __webpack_public_path__ + "static/media/WelcomeCheckGreen.c75e11e1e59bb2c2166ff99b434d9fb6.svg";
export { ForwardRef as ReactComponent };